import { render, staticRenderFns } from "./IframeDashboardFresh.vue?vue&type=template&id=dbd7fbe8&scoped=true"
import script from "./IframeDashboardFresh.vue?vue&type=script&lang=js"
export * from "./IframeDashboardFresh.vue?vue&type=script&lang=js"
import style0 from "./IframeDashboardFresh.vue?vue&type=style&index=0&id=dbd7fbe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd7fbe8",
  null
  
)

export default component.exports